export default __webpack_public_path__ + "static/media/two_way_separating.880b76df.jpg";